import * as Yup from 'yup';

export const editProfileSchema = Yup.object().shape({
  username: Yup.string().required('Please enter your full name!'),
  gender: Yup.string().required('Please select your gender!'),
  worksFor: Yup.string().required('Please enter your institute!'),
  addressRegion: Yup.string().required('Please enter your location!'),
});
